import React, { useState } from "react";
import { Dropdown, Nav } from "react-bootstrap";
import { useAuthentication } from "hooks";
import useExceptionHandler from "hooks/useExceptionHandler";
import ToolTip from "components/ToolTip/ToolTip";

export const ReturnCompanyButton = () => {
  const { volverCompaniaOriginal } = useAuthentication();
  const { handleException } = useExceptionHandler();
  const [loading, setLoading] = useState(false);

  const handleClick = () => {
    if (loading) return;
    setLoading(true);
    volverCompaniaOriginal()
      .then(() => {
        window.location.reload();
      })
      .catch((e) => {
        handleException(e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Dropdown as={Nav.Item}>
      <Dropdown.Toggle
        as={Nav.Link}
        id="dropdown-return-company"
        className="buttonHover"
        onClick={handleClick}
      >
        <ToolTip placement="left" message="Volver a compañía principal">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            fill="#77777A"
            viewBox="0 -960 960 960"
          >
            <path d="M220-180h150v-250h220v250h150v-390L480-765 220-570v390Zm-60 60v-480l320-240 320 240v480H530v-250H430v250H160Zm320-353Z" />
          </svg>
        </ToolTip>
      </Dropdown.Toggle>
    </Dropdown>
  );
};
